import {effectiveAccess,accessToLegacy} from "../access/policy";
const sectionPermissions = {
  inicio: "dashboard",
  "vexadent-ai": "ai",
  pacientes: "pacientes",
  citas: "citas",
  whatsapp: "whatsapp",
  imagenologia: "imagenologia",
  finanzas: "finanzas",
  usuarios: "usuarios",
  ajustes: "configuracion",
  logs: "logs",
};

export const moreSections = ["mas", "imagenologia", "finanzas", "usuarios", "ajustes", "logs"];

export const canAccessMobileSection = (section, permissions = {}) =>
  section === "mas" ||
  Boolean(sectionPermissions[section] && permissions[sectionPermissions[section]]);

export const resolveMobilePermissions = (clinicId, currentUser, userData) => {
  if(currentUser?.access)return accessToLegacy(effectiveAccess(currentUser));
  const legacy={...(userData?.clinicId===clinicId?userData.permisos:{}),...currentUser?.permisos};
  return {...legacy,dashboard:legacy.dashboard??legacy.pacientes,ai:legacy.ai??legacy.pacientes};
};
